import { Link, useNavigate, useParams } from "react-router-dom";
import SideBarWrapper from "../../../components/common/SideBarWrapper";
import Navbar from "../../../layout/Navbar";
import { useEffect, useState } from "react";
import { baseURL } from "../../../utils/misc";
import useAuth from "../../../hooks/useAuth";
import LogisticsForm from "../../../components/LogisticsRecords/LogisticsForm";
import Footer from "../../../layout/Footer";
import { toast } from "react-toastify";

const EditLogisticsRecord = () => {
    const { logisticsId } = useParams();
    const [logisticsRecord, setLogisticsRecord] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!(user && user.user.token)) {
            navigate('/login');
            toast.warn("You seem to have lost your access token. Please try again later.");
            return;
        }
        // Fetch workflow process data when the component mounts
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${user.user.token}`,
                }
            };

            try {
                const response = await fetch(`${baseURL}/logisticsrecords/${logisticsId}`, requestOptions);

                if (response.ok) {
                    const data = await response.json();
                    setLogisticsRecord(data);
                } else {
                    console.error('Error fetching logistics record data');
                }
            } catch (error) {
                console.error('Error fetching logistics record data:', error);
            }
        };

        fetchData();
    }, [logisticsId, navigate, user]);



    return (<>


        {/* Page wrapper start */}
        <div className="page-wrapper">

            {/* Sidebar wrapper start */}
            <SideBarWrapper />
            {/* Sidebar wrapper end */}

            {/* Page content start  */}
            <div className="page-content">

                {/* Header start */}
                <Navbar />
                {/* Header end */}

                {/* Page header start */}
                <div className="page-header">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                        <li className="breadcrumb-item">{logisticsRecord && logisticsRecord && logisticsRecord.code}</li>
                        <li className="breadcrumb-item">
                            <Link to={`/logisticsrecords/crop/${logisticsRecord && logisticsRecord && logisticsRecord.cropId}`} >Logistics Records</Link>
                        </li>
                        <li className="breadcrumb-item active">Edit</li>
                    </ol>
                    <ul className="app-actions">
                    </ul>
                </div>
                {/* Page header end */}

                {/* Main container start */}
                <div className="main-container">
                    {logisticsRecord && <LogisticsForm crop={logisticsRecord && logisticsRecord.crop} logisticsRecord={logisticsRecord && logisticsRecord} setLogisticsRecord={setLogisticsRecord}/>}
                </div>
                {/* Main container end */}

            </div>
            {/* Page content end */}
            <Footer/>

        </div>
        {/* Page wrapper end */}
    </>);
}

export default EditLogisticsRecord;